import { render, staticRenderFns } from "./PopsEngClinic.vue?vue&type=template&id=7cf80265&scoped=true"
import script from "./PopsEngClinic.vue?vue&type=script&lang=js"
export * from "./PopsEngClinic.vue?vue&type=script&lang=js"
import style0 from "./PopsEngClinic.vue?vue&type=style&index=0&id=7cf80265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf80265",
  null
  
)

export default component.exports